<script setup>
/**
 * FormControlPagesTemplateId
 * Core orchestrator driving page template selections and visual preview states.
 * Connects directly to global blueprint catalogs to toggle layout configuration
 * panels and mobile simulation frames depending on the active page state.
 */
import { computed, onMounted, getCurrentInstance } from 'vue';
import FormControlTypeSelect from '../form-control-type/FormControlTypeSelect.vue';
import PageContentTemplateContent from "../page-content/PageContentTemplateContent.vue";
import PageContentMobile from "../page-content/PageContentMobile.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    }
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Synchronous Computeds ---

const pageId = computed(() => props.currentData?.id);

const betaMode = computed(() => store.state.betaMode || false);

const pageTemplates = computed(() => store.getters['templates/pageTemplates'] || []);

/**
 * Generates options picklists for the baseline selector component.
 * FIX: Guarantees a default placeholder array instead of returning undefined,
 * shielding your template layers from aggressive mounting/unmounting flashes.
 */
const options = computed(() => {
    const baselineOptions = [{
        value: '',
        text: 'Select…'
    }];

    const templatesArray = pageTemplates.value;

    if (templatesArray.length > 0) {
        templatesArray.forEach((templateItem) => {
            baselineOptions.push({
                value: templateItem.id,
                text: templateItem.title
            });
        });
    }

    return baselineOptions;
});

// --- Methods ---

/**
 * Safe, isolated callback placeholder required by child visual simulation blocks.
 */
const handleHideModalPlaceholder = () => {};
</script>

<template>
    <div class="form-control-pages-template-id-wrapper">

        <FormControlTypeSelect
            v-if="options && (betaMode || !currentData.templateId)"
            :current-data="currentData"
            :field="field"
            :form-id="formId"
            :options="options"
        />

        <PageContentTemplateContent
            v-if="currentData.templateId"
            :form-id="formId"
            :template-id="currentData.templateId"
        />

        <div v-if="pageId" class="mt-3">
            <PageContentMobile
                :page-id="pageId"
                :hide-modal="handleHideModalPlaceholder"
            />
        </div>

    </div>
</template>